<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Form - REVISI Order Pasang Iklan
                <div class="card-header-actions">
                <button  class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save" v-if="saveEnabled"></i> Save</button>
                <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close Form</b-button>
                </div>
            </div>
              <b-row class="expand-input">
                <b-col lg="6">
                  <b-row>
                      <b-col lg="6">
                        <b-input-group >
                          <b-input-group-prepend><label>OPI# DI-REVISI</label></b-input-group-prepend>
                          <b-form-input v-model="model.orderno" readonly ></b-form-input>
                          <b-input-group-append>
                            <b-btn variant="primary" text="Button" @click="lkuOpiShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                          </b-input-group-append>
                        </b-input-group>
                      </b-col>
                      <b-col lg="6">
                        <b-input-group >
                          <b-input-group-prepend><span class="ml-2 mr-1 pt-2">TGL. REVISI</span></b-input-group-prepend>
                          <b-form-input v-model="model.revisiondate"  type="date" :disabled="(model.revisionkey)" ></b-form-input>
                        </b-input-group>
                      </b-col>
                  </b-row>
                  <b-input-group >
                      <b-input-group-prepend><label>ALASAN REVISI</label></b-input-group-prepend>
                    <b-form-input placeholder="Alasan Revisi" v-model="model.uraian" :state="$v.model.uraian.$dirty ? !$v.model.uraian.$error : null"></b-form-input>
                  </b-input-group>
                  </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Platform Media</label></b-input-group-prepend>
                      <b-form-radio-group class="mt-2" v-model="model.platform" disabled>
                        <b-form-radio value="cetak">Cetak/Newspaper</b-form-radio>
                        <b-form-radio value="website">Online Website</b-form-radio>
                        <b-form-radio value="mobile">Online Mobile</b-form-radio>
                      </b-form-radio-group>
                      <b-input-group-append v-if="($v.model.platform.$dirty && !$v.model.platform.$error)">
                            <span style="text-align:right; color:red;">required</span>
                      </b-input-group-append>
                    </b-input-group>
                  <b-row>
                      <b-col lg="6">
                        <b-input-group >
                            <b-input-group-prepend><label>Tanggal OPI</label></b-input-group-prepend>
                          <b-form-input v-model="model.orderdate" disabled type="date" class="mr-2"></b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col lg="6">
                        <b-input-group >
                          <b-input-group-prepend><span class="ml-2 mr-1 pt-2">Sales Order</span></b-input-group-prepend>
                            <b-form-input placeholder="Pilih Sales Order" v-model="model.mediaorder" readonly></b-form-input>
                        </b-input-group>
                      </b-col>
                  </b-row>
                  <b-input-group >
                      <b-input-group-prepend><label>Pemasang</label></b-input-group-prepend>
                      <b-form-input placeholder="Masukkan Nama Pemasang" v-model="model.pemasang" disabled></b-form-input>
                      <b-input-group-prepend><span class="input-group-text">u.p Invoice</span></b-input-group-prepend>
                  </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Nama Biro Iklan</label></b-input-group-prepend>
                      <b-form-input placeholder="Pilih Biro Iklan" v-model="model.custinfo" readonly></b-form-input>
                  </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Advertiser</label></b-input-group-prepend>
                    <b-form-input placeholder="Masukkan Advertiser" v-model="model.Advertiser" disabled></b-form-input>
                  </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Brand</label></b-input-group-prepend>
                      <b-form-input placeholder="Masukkan Brand" v-model="model.brand" disabled></b-form-input>
                      <b-input-group-prepend><span class="ml-2 mr-1 pt-2">Category</span></b-input-group-prepend>
                    <b-form-input placeholder="Masukkan Category" v-model="model.kategori" disabled></b-form-input>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Nama Sales AE</label></b-input-group-prepend>
                    <b-form-input placeholder="Pilih Sales AE" v-model="model.SalesEx" readonly></b-form-input>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Jenis Iklan</label></b-input-group-prepend>
                    <b-form-input placeholder="Pilih Jenis Iklan"  v-model="model.jiklan" readonly></b-form-input>
                      <b-input-group-prepend><span class="ml-2 mr-1 pt-1">Warna</span></b-input-group-prepend>
                      <b-form-radio-group v-model="model.jwarna" id="jwarna" inline class="p-1" disabled @change="changeWarna">
                        <b-form-radio value="BW">BW</b-form-radio>
                        <b-form-radio value="Warna">FC</b-form-radio>
                      </b-form-radio-group>
                  </b-input-group>
                  <b-row>
                    <b-col md="6">
                        <b-input-group >
                          <b-input-group-prepend><label>Harga Satuan</label></b-input-group-prepend>
                          <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                          <my-number v-model="model.price" class="text-right" readonly></my-number>
                        </b-input-group>                      
                    </b-col>
                    <b-col md="6">
                      <b-input-group v-if="groupiklan !== '2' || groupiklan !== 2">
                        <b-input-group-prepend><span class="pt-2 mr-2">Ukuran Iklan (lebar x tinggi)</span></b-input-group-prepend>
                        <b-form-input placeholder="Lebar/Kolom" v-model="model.kol" type="number" disabled class="small-input"></b-form-input>
                        <b-input-group-append><span class="input-group-text"> x </span></b-input-group-append>
                        <b-form-input placeholder="Tinggi/Milimeter" v-model="model.mili" type="number"  disabled class="small-input"></b-form-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <div v-if="groupiklan === '2' || groupiklan === 2">
                    <b-input-group :append="model.baris1.length>9?model.baris1.length.toString() : '0'+model.baris1.length.toString() || '00'">
                      <b-input-group-prepend><label>Materi Iklan Baris</label></b-input-group-prepend>
                      <b-form-input v-model="model.baris1" maxlength="40" placeholder="Baris 1"></b-form-input>
                    </b-input-group>
                    <b-input-group :append="model.baris2.length>9?model.baris2.length.toString() : '0'+model.baris2.length.toString() || '00'">
                      <b-input-group-prepend><label> </label></b-input-group-prepend>
                      <b-form-input v-model="model.baris2" maxlength="40" placeholder="Baris 2"></b-form-input>
                    </b-input-group>
                    <b-input-group :append="model.baris3.length>9?model.baris3.length.toString() : '0'+model.baris3.length.toString() || '00'">
                      <b-input-group-prepend><label> </label></b-input-group-prepend>
                      <b-form-input v-model="model.baris3" maxlength="40" placeholder="Baris 3"></b-form-input>
                    </b-input-group>
                    <b-input-group :append="model.baris4.length>9?model.baris4.length.toString() : '0'+model.baris4.length.toString() || '00'">
                      <b-input-group-prepend><label> </label></b-input-group-prepend>
                      <b-form-input v-model="model.baris4" maxlength="40" placeholder="Baris 4"></b-form-input>
                    </b-input-group>
                    <b-input-group :append="model.baris5.length>9?model.baris5.length.toString() : '0'+model.baris5.length.toString() || '00'">
                      <b-input-group-prepend><label> </label></b-input-group-prepend>
                      <b-form-input v-model="model.baris5" maxlength="40" placeholder="Baris 5"></b-form-input>
                    </b-input-group>
                    <b-input-group :append="model.baris6.length>9?model.baris6.length.toString() : '0'+model.baris6.length.toString() || '00'">
                      <b-input-group-prepend><label> </label></b-input-group-prepend>
                      <b-form-input v-model="model.baris6" maxlength="40" placeholder="Baris 6"></b-form-input>
                    </b-input-group>
                    <b-input-group :append="model.baris7.length>9?model.baris7.length.toString() : '0'+model.baris7.length.toString() || '00'">
                      <b-input-group-prepend><label> </label></b-input-group-prepend>
                      <b-form-input v-model="model.baris7" maxlength="40" placeholder="Baris 7"></b-form-input>
                    </b-input-group>
                    <b-input-group :append="model.baris8.length>9?model.baris8.length.toString() : '0'+model.baris8.length.toString() || '00'">
                      <b-input-group-prepend><label> </label></b-input-group-prepend>
                      <b-form-input v-model="model.baris8" maxlength="40" placeholder="Baris 8"></b-form-input>
                    </b-input-group>
                     <b-input-group :append="getTotalKarakter">
                      <b-input-group-prepend><label>Jumlah Baris Iklan</label></b-input-group-prepend>
                      <b-form-input v-model="model.jmlbaris" readonly></b-form-input>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col lg="6">                  
                  <b-input-group >
                    <b-input-group-prepend><label>Judul/Keterangan</label></b-input-group-prepend>
                    <b-form-input placeholder="Judul/Keterangan/Kelompok IB" v-model="model.juduliklan" :state="$v.model.juduliklan.$dirty ? !$v.model.juduliklan.$error : null"></b-form-input>
                  </b-input-group>
                  <b-input-group v-if="groupiklan === '0' || groupiklan === 0" >
                    <b-input-group-prepend><label>Position/Rubrik</label></b-input-group-prepend>
                    <b-form-input v-model="model.posisirubrik" disabled></b-form-input>
                      <b-input-group-prepend><span class="ml-2 pt-1 mr-1">Materi Iklan</span></b-input-group-prepend>
                      <b-form-radio-group id="materijadi" label-for="materiIklan-input" inline class="p-1" v-model="model.materijadi" disabled>
                        <b-form-radio value='1'>Jadi</b-form-radio>
                        <b-form-radio value='0'>Mentah</b-form-radio>
                      </b-form-radio-group>
                  </b-input-group>
                  <!-- <b-row>
                    <b-col cols="6"> -->
                      <b-input-group >
                        <b-input-group-prepend><label>Frekuensi Muat</label></b-input-group-prepend>
                        <b-form-input @change="getGrossDescription" v-model="model.jmlmuat" type="number" :state="$v.model.jmlmuat.$dirty ? !$v.model.jmlmuat.$error : null" ></b-form-input>
                        <b-input-group-append><span class="input-group-text"> hari </span></b-input-group-append>
                          <b-form-radio-group
                            v-model="model.ispaket"
                            :options="options_ispaket"
                            name="radio-inline"
                            class="ml-2 pt-1"
                          ></b-form-radio-group>
                         <b-form-checkbox v-model="model.billb4comp" inline class="pt-1 ml-2 bg-warning"  value=1 unchecked-value=0 >Invoicing setiap akhir bulan, jika iklan lebih dari 1 bulan</b-form-checkbox>
                  </b-input-group>
                    <!-- </b-col>
                  </b-row> -->
                  <b-row class="justify-content-center mb-0" >
                      <v-date-picker
                        v-model="tgl_akan_muat"
                        :columns="layout.columns"
                        :rows="layout.rows"
                        :is-expanded="layout.isExpanded"
                        :min-date="minDate"
                        @dayclick="selectDate"
                        mode="multiple"
                        is-inline class="ml-5"
                      />
                  </b-row>
                  <b-row v-if="tgl_akan_muat.length>0" class="justify-content-center mb-0">
                    <span class="pt-2">Selected {{tgl_akan_muat.length}} Date</span>
                  </b-row>
                </b-col>
              </b-row>
              <hr>
              <b-row class="expand-input">
                <b-col lg="6">
                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>Gross</label></b-input-group-prepend>
                        <b-form-input v-model="model.grossdesc" placeholder="gross description"></b-form-input>
                        <b-input-group-append>
                          <b-btn variant="secondary" text="Button" @click="calcGross" v-b-tooltip.hover title="Hitung Gross dari Formula disamping">
                              <i class="fa fa-calculator"></i>
                          </b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.gross" :precision="2"></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>Discount</label></b-input-group-prepend>
                        <b-form-select v-model="model.calcDisc" :plain="true" :options="calcuationDisc" ></b-form-select>
                        <my-number class="text-right ml-1" v-model="model.diskonpc" :readonly="(model.calcDisc===0)" type="number"></my-number>
                        <b-input-group-append><span class="input-group-text">% &nbsp;&nbsp;&nbsp;</span></b-input-group-append>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.diskon" :readonly="(model.calcDisc===1)" :precision="2"></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="7">
                    <b-input-group >
                      <b-input-group-prepend><label>Pendapatan Lain</label></b-input-group-prepend>
                      <b-form-input v-model="model.revlaindesc"  placeholder="contoh: pembuatan materi"></b-form-input>
                    </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.revlain" :precision="2"></my-number>
                      </b-input-group>                                            
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>Netto</label></b-input-group-prepend>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.dpp" :precision="2"></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>PPN</label></b-input-group-prepend>
                        <b-form-select v-model="model.calcVAT" :plain="true" :options="calcuationVAT" ></b-form-select>
                        <b-form-input value=10 readonly class="text-right ml-1"></b-form-input>
                        <b-input-group-append><span class="input-group-text">% &nbsp;&nbsp;&nbsp;</span></b-input-group-append>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.ppn" :readonly="(model.calcVAT===1)" :precision="2"></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>Grand Total</label></b-input-group-prepend>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.total" :precision="2" readonly></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                </b-col>
                <b-col lg="6">
                  <b-row no-gutters>
                    <b-col md="6">
                        <b-input-group >
                          <b-input-group-prepend><label>Bentuk Pembayaran</label></b-input-group-prepend>
                          <b-form-select v-model="model.jenisbayar" :plain="true" class="mr-2">
                            <option value="cash/bank" selected>Cash/Bank (Uang)</option>
                            <option value="barang">Barter Barang</option>
                            <option value="fasilitas">Barter Fasilitas</option>
                            <option value="compliment">Compliment/Bonus</option>
                            <option value="stoper">Stoper</option>
                          </b-form-select>
                        </b-input-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-input v-model="model.keteranganbayar" placeholder="Keterangan Bentuk Pembayaran"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-input-group >
                    <b-input-group-prepend><label>Cara Pembayaran</label></b-input-group-prepend>
                      <b-form-radio-group inline class="p-1" v-model="model.iscash" disabled>
                        <b-form-radio value=0>Invoicing</b-form-radio>
                        <b-form-radio value=1>Tunai(dibayar dimuka)</b-form-radio>
                      </b-form-radio-group>
                    <b-form-input v-model="model.oncashnote" placeholder="Keterangan Cara Pembayaran" disabled></b-form-input>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Tujuan Invoice</label></b-input-group-prepend>
                      <b-form-radio-group inline class="p-1" v-model="model.billtoadv" :state="$v.model.billtoadv.$dirty ? !$v.model.billtoadv.$error : null">
                        <b-form-radio value=0>Client(Biro Iklan)</b-form-radio>
                        <b-form-radio value=1>Advertiser</b-form-radio>
                      </b-form-radio-group>
                      <b-form-checkbox v-model="model.proforma" id="proforma" inline class="pt-1 ml-2"  value=1 unchecked-value=0>Invoicing FuLL diawal/sebelum iklan dimuat/komplit</b-form-checkbox>
                  </b-input-group>
                  <div class="bordered"></div>
                  <transition name="slide-fade">
                    <div v-if="model.billtoadv === '1' || model.billtoadv === 1">
                      <b-input-group>
                        <b-input-group-prepend><label>Nama Advertiser</label></b-input-group-prepend>
                        <b-form-input v-model="model.advnama" placeholder="Nama Advertiser sesuai NPWP" style="width:40% !important;"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">NPWP</span></b-input-group-prepend>
                        <b-form-input v-model="model.advnpwp" placeholder="NPWP"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label>Alamat Advertiser</label></b-input-group-prepend>
                        <b-form-input v-model="model.advaddr1" placeholder="Alamat 1"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label> </label></b-input-group-prepend>
                        <b-form-input v-model="model.advaddr2" placeholder="Alamat 2"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label>Telepon</label></b-input-group-prepend>
                        <b-form-input v-model="model.advtelp" placeholder="No Telepon"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Fax</span></b-input-group-prepend>
                        <b-form-input v-model="model.advcity" placeholder="No. Fax"></b-form-input>
                      </b-input-group>
                    </div>
                      </b-input-group>
                  </transition>
                  </b-col>
              </b-row>
            <hr>

            <b-row class="justify-content-center mb-2">
                <button  class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save" v-if="saveEnabled"></i> Save</button>
                <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close Form</b-button>
    
            </b-row>

        </b-card>
        <b-modal v-model="lkuOpiShow" size="lg" :hide-footer="true" title="List of OrderPasang Iklan (OPI)"  :centered="true">
            <lku-opi @click="onSelectLkuOpi" ></lku-opi>
        </b-modal>        

    </div>
</template>
<style scoped>
/* .my-datepicker >>> .my-datepicker_calendar {
  width: 100%;
  height: 30px;
} */
.vc-container {
  margin: 10px 10px 10px 10px!important;
}
</style>
<style lang="scss">
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
        table {
            font-size: smaller;
            th {
                border: 1px solid silver;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }

            td {
                border: 1px solid silver;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }

            td.grdtotal {
                border-top: 2px solid #000 !important;
                border-bottom: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 90px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import VCalendar from 'v-calendar';
import opi from "../../apis/koran_iklanorderrevision";
import moment from 'moment';
import accounting from 'accounting-js'
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import lkuOpi from "../lookup/lkuKoraniklan";


toastr.init();


function compareNumbers(a, b) {
  return a - b;
}
export default {
  mixins: [validationMixin],
  validations: {
    model: {
        uraian: { required }, 
        platform: { required }, 
        orderdate: { required }, 
        pemasang: { required }, 
        customer_id: { required }, 
        brand: { required }, 
        kategori: { required }, 
        Advertiser: { required }, 
        juduliklan: { required },
        materijadi: { required },
        accexec: { required },
        jiklanid: { required },
        jiklan: { required },
        jwarna: { required },
        kol: { required },
        mili: { required },
        ispaket: { required },
        jmlmuat: { required },
        iscash: { required },
        gross: { required },
        grossdesc: { required },
        diskon: { required },
        diskonpc: { required },
        dpp: { required },
        ppn: { required },
        revlain: { required },
        total: { required },
        billb4comp: { required },
        billtoadv: { required },
        proforma: { required },
        billtoadv: { required },
        jenisbayar: { required }
    },
  }, 
  components:{myNumber, lkuOpi},
  data() {
    return {
      lkuCustomerShow: false,
      lkuSalesaeShow: false,
      lkuJenisIklanShow: false,
      lkuOpiShow: false,
      lkuSoData:{},
      selectedIklan: {},
      saveEnabled:true,
      minDate: new Date(),
      uanguser: this.$store.state.user.matauang,
      options_ispaket: [
          { text: 'Satuan', value: '0' },
          { text: 'Paket/Kontrak', value: '1' }
      ],
      orderLines:[],
      tgl_akan_muat:[],
      calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
      calcuationDisc : [{ value: 1, text: 'Disc (Auto Calc)' }, { value: 0, text: 'Disc (Manual Calc)' }],

      model:{
        platform: 'cetak',
        orderno: '',calcVAT:1, calcDisc:1,
        orderdate: moment().format('YYYY-MM-DD'), 
        pemasang: '', 
        custinfo: '',
        customer_id: '', 
        customer_name: '', 
        Advertiser: '', 
        mediaorder: '', 
        juduliklan: '', 
        kol: 0, 
        mili: 0, 
        ispaket: 0,
        jmlmuat: 0,
        kategori: '',
        brand: '',
        jiklanid: '',
        jiklan: '',
        classad:0,
        jwarna: 'BW',
        posisirubrik: '',
        materijadi: 1,
        matauang: this.$store.state.user.matauang,
        iscash: 0,
        oncashnote: '',
        jttempo: '',
        gross: 0,
        grossdesc: '',
        diskon: 0,
        diskonpc: 0,
        dpp: 0,
        ppn: 0,
        revlain: 0,
        revlaindesc: '',
        total: 0,
        totaliklan: 0,
        billb4comp: 0,
        proforma: 0,
        billtoadv: 0,
        advnama: '',
        advnpwp: '',
        advaddr1: '',
        advaddr2: '',
        advcity: '',
        advtelp: '',
        accexec: '',
        completeda: null,
        isstoped: 0,
        invoiceno: '',
        invoicedate: null,
        isinvoiced: 0,
        jmlbaris: 0,
        baris1: '',
        baris2: '',
        baris3: '',
        baris4: '',
        baris5: '',
        baris6: '',
        baris7: '',
        baris8: '',
        jenisbayar: 'uang',
        keteranganbayar: '',
        posted: 0,
        createby: this.$store.state.user.username,
        compcode: this.$store.state.user.compcode,
      },
    };
  },
  computed: {
    getTotalKarakter() {
      let jml = 0;
      let jmlbaris = 0;
      for (let i=1;i<=8;i+=1) {
        const val = this.model['baris'+i];
        if (val.length > 0) {
          jmlbaris += 1;
          jml += val.length;
        }
      }
      this.model.jmlbaris = jmlbaris;
      return jml > 9 ? jml.toString() : '0' + jml.toString() || '00';
    },
    layout() {
      return this.$screens(
        {
          // Default layout for mobile
          default: {
            columns: 1,
            rows: 1,
            isExpanded: true,
          },
          // Override for large screens
          md: {
            columns: 2,
            rows: 1,
            isExpanded: false,
          },
          lg: {
            columns: 2,
            rows: 1,
            isExpanded: false,
          },
        },
      );
    },
    tblFields(){
      const fields=[
          {
            key: "orderno",
            label: "Order No",
            sortable: true
          },
          {
            key: "orderdate",
            label: "Date",
            sortable: true
          },
          "pemasang",
          "Advertiser",
          {
            key: "juduliklan",
            label: "Judul Iklan",
            // thStyle: "width:60px",
            // thClass: "text-center",
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          } 
         ];
      return fields;
    },
    invalidFormdata() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    groupiklan() {
      return this.model.classad;
    },
    gross(){
        return this.model.gross;
    },    
    discpc(){
        return this.model.diskonpc;
    },    
    discvalue(){
        return this.model.diskon;
    },    
    revlain(){
      return this.model.revlain;
    },
    vattotal(){
        return this.model.ppn;
    },    
  },
  watch: {
    gross: function(newval) {
        if (this.model.calcDisc == 1){
          this.model.diskon = parseFloat(newval) * parseFloat(this.model.diskonpc) / 100;;        
        }
        this.calcTaxes();
    },  
    discpc: function(newval) {
        if (this.model.calcDisc == 1){
          this.model.diskon = parseFloat((this.model.gross || 0)) * parseFloat(this.model.diskonpc) / 100;;        
          this.calcTaxes();
        }
    },    
    discvalue: function(newval) {
        // this.model.diskonpc = parseFloat(accounting.formatNumber(this.model.diskon/this.model.gross)) * 100;
        this.model.diskonpc = (parseFloat(this.model.diskon)/parseFloat(this.model.gross)) * 100;
        this.calcTaxes();
    },  
    revlain: function(newval) {
        this.calcTaxes();
    },  
    vattotal: function(newval) {
        this.model.total = this.model.dpp + this.model.ppn;
    },    
    'model.jmlbaris': function () {
      this.getGrossDescription();
    },
    'model.kol': function () {
      this.getGrossDescription();
    },
     'model.mili': function () {
      this.getGrossDescription();
    }

  },
  created: async function(){
        if (this.$route.params.revisionkey)  {
          toastr.info('Loading OPI Detail, please wait')
          try {
            console.log('this.$route.params: ', this.$route.params);
            const data = await opi.detailRevisi(this.$route.params);  
            const row = data[0];
            console.log('row: ', row);
            this.saveEnabled=(row.posted === 0);
            row.revisiondate = row.revisiondate ? moment(row.revisiondate).format('YYYY-MM-DD') : '';
            row.orderdate = row.orderdate ? moment(row.orderdate).format('YYYY-MM-DD') : '';

            for (var key in row) {
                this.model[key] = row[key];
            }
            // this.selectedIklan.classad = this.model.classad;
            // this.selectedIklan.jiklanid = this.model.jiklanid;
            // this.selectedIklan.hargabw = this.model.hargabw;
            // this.selectedIklan.hargafc = this.model.hargafc;
            // this.selectedIklan.uraian = this.model.uraian_jiklan;

            this.orderLines =data[1];
            this.selectedIklan = data[2];
            let tgl_akan_muat = [];
            this.orderLines.forEach((jd,idx)=>{
              this.tgl_akan_muat.push(new Date(jd.jadwalmuat));
              // this.tgl_akan_muat.push(jd.jadwalmuat);
              this.orderLines[idx].jadwalmuat = moment(jd.jadwalmuat).format('YYYY-MM-DD');
            });
            // this.minDate = lines && lines.length>0 ? (new Date(lines[0].jadwalmuat) < new Date() ? new Date(lines[0].jadwalmuat) : new Date()) : new Date();

            // this.getGrossDescription();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
        } else {
            this.model.revisiondate  = moment().format('YYYY-MM-DD');
        }
  },
  methods: {
    calcGross: function() {
        try {   
            if (this.model.grossdesc) {
                let geval=eval;
                let NilaiFix = geval(`${this.model.grossdesc};`);
                this.model.gross = NilaiFix || 0;
            } else {
                toastr.info('isi Gross description dg Formula, contoh: (5 * 100 * 100) ','INFO',10000);
            }

        } catch (error) {
            console.log('error : ', error);
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },
    calcTaxes : function() {
        this.model.totaliklan = this.model.gross - this.model.diskon;
        this.model.dpp = this.model.totaliklan + this.model.revlain;
        if (this.model.calcVAT == 1){
            this.model.ppn = 0.1 * this.model.dpp;
        }
      this.model.total = this.model.dpp + this.model.ppn;

        this.$forceUpdate();
    },    
    selectDate(val) {
      if (val.date>this.minDate){
          const date = moment(val.date).format('YYYY-MM-DD');
          const index = this.orderLines.findIndex(line => line.jadwalmuat === date);      
          // const index = this.orderLines.indexOf(date);
          if (index > -1) {
            this.tgl_akan_muat.splice(index, 1);
            this.orderLines.splice(index, 1);
          } else {
            this.tgl_akan_muat.push(new Date(date));
            this.orderLines.push({jadwalmuat: date});
          }
          // HITUNG QTY MUAT & GROSS DESCRIPTION
          // this.model.jadwalmuat = this.tgl_akan_muat.length;
          // this.model.jmlmuat = this.tgl_akan_muat.length;
          // this.getGrossDescription();
      }
    },
    changeWarna(val) {
      if(this.selectedIklan) {
        if(val==="BW"){
            this.model.price = this.selectedIklan.hargabw;
        } else {
            this.model.price = this.selectedIklan.hargafc;
        }
      } else {
          this.model.price = 0;
      }
      this.getGrossDescription();
    },
    getGrossDescription () {

      if(this.groupiklan === '2' || this.groupiklan === 2 || this.groupiklan === 2) {
        // GET GROSS
        // this.model.grossdesc = `( ${this.model.jmlmuat} * ${this.model.jmlbaris} * ${accounting.formatNumber(this.model.price, 0)} )`;
        this.model.grossdesc = `( ${this.model.jmlmuat} * ${this.model.jmlbaris} * ${this.model.price} )`;
        this.model.ukuraniklan = '';
        const gross = this.model.jmlmuat * this.model.jmlbaris * this.model.price;
        this.model.gross = gross;
      } else {
        // GET GROSS
        // this.model.grossdesc = `( ${this.model.jmlmuat} * ${this.model.kol} * ${this.model.mili} * ${accounting.formatNumber(this.model.price, 0)} )`;
        this.model.grossdesc = `( ${this.model.jmlmuat} * ${this.model.kol} * ${this.model.mili} * ${this.model.price} )`;
        this.model.ukuraniklan = `${this.model.kol} * ${this.model.mili}`;
        const gross = this.model.jmlmuat * this.model.kol * this.model.mili * this.model.price;
        this.model.gross = gross;
      }
  
      // GET DISCOUNT
      let disc = parseFloat(accounting.formatNumber(this.model.diskon/this.model.gross)) * 100;
      this.model.diskonpc = isNaN(disc) ? 0 : disc;
      // GET NETTO
      this.model.dpp = this.model.gross - this.model.diskon;
      // GET TAX
      this.model.ppn = 0.1 * this.model.dpp;
      // GET TOTAL
      this.model.totaliklan = this.model.dpp + this.model.ppn;
      // GET GRAND TOTAL
      this.model.total = this.model.totaliklan + this.model.revlain;
      // GET SILENT DISC %
      let silent_pc = parseFloat(accounting.formatNumber(this.model.silentdisc/this.model.total)) * 100;
      this.model.silent_pc = isNaN(silent_pc) ? 0 : silent_pc;
      // GET TOTAL PAYMENT
      this.total_bayar = this.model.total - this.model.silentdisc;
    },
 
    onSelectLkuOpi: async function (_selected) {
      opi.detail({ orderid: _selected.orderid}).then((data)=>{
            this.orderLines =data[1];
            this.selectedIklan = data[2];
            this.orderLines.forEach((jd,idx)=>{
              this.tgl_akan_muat.push(new Date(jd.jadwalmuat));
              // this.tgl_akan_muat.push(jd.jadwalmuat);
              this.orderLines[idx].jadwalmuat = moment(jd.jadwalmuat).format('YYYY-MM-DD');
            });
          this.lkuOpiShow=false;
      });

        for (var key in _selected) {
            this.model[key] = _selected[key];
        }
            this.model.orderdate = _selected.orderdate ? moment(_selected.orderdate).format('YYYY-MM-DD') : '';
        // this.updateDimDtl2Hdr(_selected);
    },    
    // onSelectLkuJenisIklan: function (_selected) {
    //   this.model.jiklanid = _selected.jiklanid;
    //   this.model.jiklan = _selected.jenisiklan;
    //   this.model.classad = _selected.classad;
    //   this.model.jwarna = 'BW';
    //   this.model.price = _selected.hargabw;
       
    //   this.selectedIklan =  _selected;
    //   this.getGrossDescription();
    //   this.lkuJenisIklanShow=false;
    // },    
    // clear() {
    //    this.tgl_akan_muat = [];
    //    this.orderLines = [];
    //   //  this.model.jmlmuat = 0;
    //    this.getGrossDescription();
    // },
    save: async function (callback) {
      const user = this.$store.state.user.username;
      const compcode = this.$store.state.user.compcode;
      if (!(this.saveEnabled)) return;
      
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.model);
              console.log('model : ',this.model);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
          } else if (Math.abs(this.model.jmlmuat - this.tgl_akan_muat.length)>0) {
              toastr.error(`Frekuensi Muat tidak sesuai dg Tanggal yg diplih ${this.model.jmlmuat} <> ${this.tgl_akan_muat.length}`, "ERROR MESSAGE");
          } else {
            try {
              const data={};
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
              // data.tgl_akan_muat = this.tgl_akan_muat.sort(compareNumbers);
              data.orderLines=this.orderLines;
              await opi.save(data);
              this.close();
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    

    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'iklankoran.orderpasangiklanfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
          // router.push("order-pasang-iklan");
           router.push({name :'iklankoran.ubahfrekuensi'});
      }
    }
  },
};
</script>
